import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';
import { Firestore } from '@angular/fire/firestore';
import { doc, setDoc } from 'firebase/firestore';


@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.css']
})
export class PasswordChangeComponent implements OnInit {
  currentPassword: string;
  newPassword: string;
  newPassConfirm: string;
  complatePasswordChange: boolean;
  FailurePasswordChange: boolean;
  PasswordConfirmInvalid: boolean;
  confirmPasswordHided = true;

  constructor(
    private auth: AuthService,
    private firestore: Firestore,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  async onSubmit(){
    this.complatePasswordChange = false;
    this.FailurePasswordChange = false;
    this.PasswordConfirmInvalid = false;

    // 新パスワード一致確認
    if (this.newPassword != this.newPassConfirm){
      this.PasswordConfirmInvalid = true;
      return;
    }

    // パスワード変更
    this.auth.changePassword(this.currentPassword, this.newPassword).then(async () => {
      console.log('complate');
      this.showSnackbar('変更しました！');
      this.complatePasswordChange = true;
      const user = await this.auth.getUser();
      const userRef = doc(this.firestore, 'users', user.uid);
      await setDoc(userRef, { passwordChanged: true }, { merge: true });

    }).catch((error)=>{
      console.log(error['code']);
      console.log(error);
      this.FailurePasswordChange = true;
    });
  }

  async showSnackbar(text: string){
    this._snackBar.open(text, undefined, { duration: 2 * 1000 });
  }
}
